import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import Icons from '../Icons';
import { Loader } from '../Loader';
import { ClearIcon, Group, Wrapper } from './styled';
const TagComponent = memo(function TagComponent({ title, infoMarker, error, isLoading, isDisabled, isInactive, onClick, onDoubleClick, onRemove, dataTestId, }) {
    const { colors } = useTheme();
    const iconColor = useMemo(() => {
        if (error) {
            return isDisabled || isInactive ? colors.critical10_1 : colors.critical100;
        }
        return isDisabled || isInactive ? colors.grey30_1 : colors.grey100_1;
    }, [error, isDisabled, isInactive, colors.grey30_1, colors.grey100_1, colors.critical10_1, colors.critical100]);
    const infoMarkerColor = useMemo(() => {
        if (error) {
            return isDisabled || isInactive ? colors.critical30_2 : colors.critical100;
        }
        return isDisabled || isInactive ? colors.grey70_1 : colors.black_1;
    }, [error, isDisabled, isInactive, colors.grey70_1, colors.black_1, colors.critical30_2, colors.critical100]);
    const handleRemove = useCallbackRef((e) => {
        e.stopPropagation();
        onRemove?.();
    });
    return (_jsxs(Wrapper, { "$error": error, "$isInactive": isInactive, "$isDisabled": isDisabled, onClick: !isDisabled ? onClick : undefined, onDoubleClick: !isDisabled ? onDoubleClick : undefined, "data-testid": dataTestId, children: [isLoading ? _jsx(Loader, { cover: true }) : null, infoMarker && _jsx(Icons.Info, { size: 16, color: infoMarkerColor, filled: true }), title, onRemove && _jsx(ClearIcon, { size: 16, color: iconColor, onClick: !isDisabled ? handleRemove : undefined, "$isDisabled": isDisabled })] }));
});
export const Tag = Object.assign(TagComponent, {
    Group,
});
